import { ProductEntryRequirementForParticipation } from '../../entities/ProductEntryRequirementForParticipation.js';
import type { RegistrationProductEntryRequirementsPlugin } from '../plugin-types.js';

export const defaultRegistrationProductEntryRequirementsPlugin: RegistrationProductEntryRequirementsPlugin = {
  id: 'registration::product-entry-requirements::default',
  type: 'registration::product-entry-requirements',
  getRequirementKinds() {
    return [ProductEntryRequirementForParticipation];
  },
};
